import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=a531bfe2&scoped=true"
import script from "./imageViewer.vue?vue&type=script&lang=js"
export * from "./imageViewer.vue?vue&type=script&lang=js"
import style0 from "./imageViewer.vue?vue&type=style&index=0&id=a531bfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a531bfe2",
  null
  
)

export default component.exports